import { TransformationProtocolDTO } from "./transformationProtocolDTO";

export class TransformationDefinitionDTO{

    public id? : number;
    public name! : string;
    public description! : string;
    public inputDefinitionType! : number;
    public inputDefinitionId! : number;
    public conformsWithFileDefinitionId? : number;
    public outputFileType! : string;
    public fieldDelimiter? : string;
    public quotedFields : boolean = false;
    public lineEnding? : string;
    public createHeaderRow : boolean = false;
    public trimValues : boolean = false;
    public transformationProtocols : TransformationProtocolDTO[] = [];
    public version? : number; //incremental version number set by server
    public published : boolean = false; //if true, then can be used for moovs and can be loaded by other users
    public added? : string;
    public deleted : boolean = false;
    public fieldDefinition? : string;
    public ownedByEntityId?: number;
    public ownerEntityType?: string;
    public transformationTreeStructure? : string;
    public encoding? : string;
    public casing? : string;
    public defaultMetadataProtocol? : string;
    public wizardSessionId? : number;

    constructor(){
    }
}